import React from 'react';
import '../global';

export default function ISDA_Library() {
    const myAccountObj = getMyAccountObj();
    return (
        <div className="online-library-container">
        <table>
            <thead>
                <tr>
                    <th>Library Account Type</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>ISDA Library Enterprise</td>
                    <td>
                        {myAccountObj.online_library === 'Active' ? 'Active' : 'Inactive'}
                    </td>
                </tr>
                <tr>
                    <td>ISDA Library Enterprise Plus</td>
                    <td>
                        {myAccountObj.online_library_plus === 'Active' ? 'Active' : 'Inactive'}
                    </td>
                </tr>
            </tbody>
            </table>
            <p>
               For information on how to subscribe to ISDA Library Enterprise or ISDA Library Enterprise Plus, please contact us at <a href={`mailto:${myAccountObj.library_status_email}`}>{myAccountObj.library_status_email}</a>. Thank you.
            </p>
        </div>
    );
}